export default "__VITE_ASSET__ug44tzJ8__"